export default __webpack_public_path__ + "static/media/bpay-icon-land.299b0c2c.png";